import type {VariantProps} from 'tailwind-variants';
import {tv} from 'tailwind-variants';
import {
  formControlSlotsBaseResizingW,
  formControlSlotsBaseResizingH,
  formControlSlotsHelperTextWrapperResizingW,
  formControlSlotsHelperTextWrapperResizingH,
  formControlSlotsBaseLayout,
  formControlSlotsHelperTextWrapperTextOverflow,
} from 'Catalyst/tokens/output/form-control';
import type {Class} from 'Catalyst/class';
import {default as FormControl} from './FormControl.svelte';
import type {HTMLInputAttributes} from 'svelte/elements';

export const formControlTvProps = tv({
  slots: {
    base: `
      ${formControlSlotsBaseResizingW}
      ${formControlSlotsBaseResizingH}
      ${formControlSlotsBaseLayout}
      space-y-[--form-control-slots-base-item-spacing]
      [font:--form-control-slots-helper-text-typography]
      font-[--form-control-slots-helper-text-font-weight]
    `,
    helperTextWrapper: `
      ${formControlSlotsHelperTextWrapperResizingW}
      ${formControlSlotsHelperTextWrapperResizingH}
      ${formControlSlotsHelperTextWrapperTextOverflow}
    `,
    helperText: `
      text-[--form-control-slots-helper-text-color]
    `,
    invalidText: `
      text-[--form-control-variants-invalid-true-helper-text-color]
      whitespace-pre-wrap
      ${formControlSlotsHelperTextWrapperTextOverflow}
    `,
  },
  variants: {
    size: {
      '40dp': {
        helperText: `
          text-[--form-control-slots-helper-text-color]
          [font:--form-control-slots-helper-text-typography]
          font-[--form-control-slots-helper-text-font-weight]
        `,
        invalidText: `
          text-[--form-control-variants-invalid-true-helper-text-color]
          whitespace-pre-wrap
          ${formControlSlotsHelperTextWrapperTextOverflow}
          [font:--form-control-slots-helper-text-typography]
          font-[--form-control-slots-helper-text-font-weight]
        `,
      },
      '56dp': {
        helperText: `
          text-[--form-control-slots-helper-text-color]
          [font:--form-control-variants-size-56dp-helper-text-typography]
          font-[--form-control-slots-helper-text-font-weight]
        `,
        invalidText: `
          text-[--form-control-variants-invalid-true-helper-text-color]
          whitespace-pre-wrap
          ${formControlSlotsHelperTextWrapperTextOverflow}
          [font:--form-control-variants-size-56dp-helper-text-typography]
          font-[--form-control-slots-helper-text-font-weight]
        `,
      },
    },
  },
  defaultVariants: {
    size: '40dp',
  },
});

export type FormControlTvProps = VariantProps<typeof formControlTvProps>;

export type FormControlProps = Omit<HTMLInputAttributes, 'size'> &
  FormControlTvProps &
  Class;

export {FormControl};
